import { resolveImageURL } from 'volto-essvoltocomponents/helpers';
import {
  ContentWrapper,
  PageSection,
  ContentNarrow,
  ContentWide,
} from 'volto-essvoltocomponents/components/Layout';
import PageHeaderBackground from '../../Molecules/PageHeaderBackground';
import RichText from '../../Atoms/RichText';
import { ESSButton } from '../../Atoms/ESSButton';

// ---------------------------------------------------------------------------
// Constants
// ---------------------------------------------------------------------------

const PAGE_SECTIONS = [
  { id: 'section-about', title: 'About the service' },
  { id: 'section-relevance', title: 'Why is this service relevant' },
];

// ---------------------------------------------------------------------------
// ServiceView
// ---------------------------------------------------------------------------

const ServiceView = ({ content }) => {
  const title = content.title;
  const titleBgImageUrl = resolveImageURL(content, '/@@images/hero_image/hero');
  const fullDescription = content.full_description?.data;
  const about = content?.about?.data;
  const relevance = content?.why_is_this_service_relevant?.data;

  const availableSections = PAGE_SECTIONS.filter((section) => {
    switch (section.id) {
      case 'section-about':
        return !!about;
      case 'section-relevance':
        return !!relevance;
      default:
        return false;
    }
  });

  const borderStyle = 'solid 1px var(--color-neutral-01)';

  return (
    <>
      <PageHeaderBackground
        title={title}
        description={fullDescription}
        showBackButton={true}
        goBackText="Go back"
        backgroundImage={titleBgImageUrl}
        blurBg={true}
      />

      {/* Menu */}
      <PageSection
        id={availableSections[0].id}
        paddingTop="var(--spacing-3)"
        paddingBottom="var(--spacing-3)"
        borderTop={borderStyle}
      >
        <ContentWrapper className="service-menu-wrapper">
          <ContentWide
            className="service-menu"
            style={{ flexDirection: 'row', flexWrap: 'wrap' }}
          >
            {availableSections.map((section) => (
              <ESSButton
                variant="link-icon"
                key={section.id}
                onClick={() =>
                  document.getElementById(section.id)?.scrollIntoView({
                    behavior: 'smooth',
                  })
                }
              >
                {section.title}
              </ESSButton>
            ))}
          </ContentWide>
        </ContentWrapper>
      </PageSection>

      {/* About */}
      {about && (
        <PageSection id={PAGE_SECTIONS[0].id} borderTop={borderStyle}>
          <ContentWrapper className="service-about-wrapper">
            <ContentWide>
              <ContentNarrow className="service-about-title">
                <h2>{PAGE_SECTIONS[0].title}</h2>
              </ContentNarrow>
              <ContentNarrow className="service-about-content">
                <RichText content={about} />
              </ContentNarrow>
            </ContentWide>
          </ContentWrapper>
        </PageSection>
      )}

      {/* Relevance */}
      {relevance && (
        <PageSection id={PAGE_SECTIONS[1].id} borderTop={borderStyle}>
          <ContentWrapper className="service-about-wrapper">
            <ContentWide>
              <ContentNarrow className="service-about-title">
                <h2>{PAGE_SECTIONS[1].title}</h2>
              </ContentNarrow>
              <ContentNarrow className="service-about-content">
                <RichText content={relevance} />
              </ContentNarrow>
            </ContentWide>
          </ContentWrapper>
        </PageSection>
      )}
    </>
  );
};

export default ServiceView;
